/* eslint-disable */
export default {
  unknown: 'Unknown',
  anonymous: 'Anonymous',
  activeCall: 'Active Call',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
